<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              輔翼優惠券 查詢
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">輔翼優惠券 查詢</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="會員代碼"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="params.member_code"
              placeholder="請輸入會員代碼"
            ></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="優惠券編號"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="params.coupon_no"
              placeholder="請輸入優惠券編號"
            ></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="優惠券狀態"
        >
          <b-input-group>
            <b-form-select
              id="status"
              class="mb-2 mr-sm-2 mb-sm-0"
              v-model="params.status"
              :options="statusOptions"
            ></b-form-select>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
        >
          <b-button
            variant="info"
            @click="handleSearch"
            :disabled="isLoading"
          >
            查詢
          </b-button>
        </b-form-group>
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="result"
          width="100%"
          height="300px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="!editable"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import flapsApi from "@/apis/flaps"


export default {
  mixins: [fileMixin],
  components: { editor },
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {};
  },
  data() {
    return {
      code: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
      canEdit: false,
      params: {
        member_code: null,
        coupon_no: null,
        status: null
      },
      statusOptions: [
        { value: null, text: '全部' },
        { value: 1, text: '未逾期' },
      ]
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    },
    editable() {
      return !this.isShownByVariableCode || this.canEdit
    },
  },
  mounted() {
    if (!this.checkPermission([consts.HTY_FLAPS_SETTING_QUERY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    }

  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools");
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },
    async handleSearch() {
      if (!this.params.member_code) {
        this.$swal.fire({
          type: "warning",
          text: "請輸入會員代碼",
        });
        return;
      }

      try {
        this.isSubmitting = true;
        this.result = "查詢中...";
        
        const result = await flapsApi.queryCoupon(this.params);
        this.result = JSON.stringify(result.data, null, 2);
      } catch (error) {
        this.result = JSON.stringify(error.response?.data || error.message, null, 2);
      }
      this.isSubmitting = false;
    },

    async handleSubmit(redirect = true) {
      const result = await this.v$.$validate();
      if (!result) return;
      this.handleUpdate(redirect);
    },
    showSuccessPopup(redirect = true) {
      this.$swal
        .fire({
          type: "success",
          text: "修改成功",
        })
        .then(() => {
          if (redirect) {
            this.$router.push({
              name: this.isByMerchant
                ? "OrganizationVariableListByMerchant"
                : "OrganizationVariableList",
            });
          }
        });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>

